<template>
  <div>
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(100)"
    >
      <template slot-scope="{ row, index }" slot="filesArr">
        <viewer v-if="row.filesArr">
          <img
            v-for="(x, index) in row.filesArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      columns: [
        {
          title: "订单号",
          key: "ono",
          width: 130,
        },
        {
          title: "状态",
          key: "status2",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        /* {
          title: "费用项目",
          key: "costName",
        }, */
        {
          title: "币别",
          key: "currency",
        },
        {
          title: "类别",
          key: "voucherType2",
        },
        {
          title: "金额",
          key: "money",
        },
        {
          title: "到账日期",
          key: "accountDate2",
        },
        {
          title: "附件",
          key: "fileUrl",
          slot: "filesArr",
        },
        {
          title: "台账账号",
          key: "tallyAccount",
        },
        {
          title: "台账余额",
          key: "tallyAccountMoney",
        },
        {
          title: "操作员",
          key: "creator",
        },
        {
          title: "操作时间",
          key: "createTime2",
        },
        {
          title: "备注",
          key: "remark",
        },
      ],
      tableData: [],

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        cid: "",
        ono: "",
        keyWork: "",
        voucherType: 0,
        ordersChargesId: 0,
      },
      total: 0,
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    reach(v) {
      this.searchItem.ono = v.ono;
      this.searchItem.ordersChargesId = v.id;
      this.searchItem.voucherType = v.voucherType;
      this.getList();
    },
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tallyBook/list",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var status = { 0: "正常", 1: "作废" };
        var voucherType = { 0: "收入", 1: "支出" };
        for (let i = 0; i < data.length; i++) {
          data[i].status2 = status[data[i].status];
          data[i].voucherType2 = voucherType[data[i].voucherType];
          data[i].accountDate2 = this.utils.time(data[i].accountDate, "yymmdd");
          data[i].createTime2 = this.utils.time(data[i].createTime);
          data[i].filesArr = this.utils.strToJson(data[i].fileUrl);
        }
        this.tableData = data;
        console.log(data);
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols([], this.columns, config);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/shouzhijiluList.vue